// キャンバスオブジェクトの id 採番。
//
// 「createObjects へ渡す前に id を確定したい」経路（コネクタの端点 id を先に決める必要がある
// 貼り付け複製・Alt+ドラッグ複製・コネクタからの自動作成）のための単一正本。
// dispatcher 内部の採番と同じ文字種・長さにそろえてある。
//
// 既存の重複定義（use-canvas-op-dispatcher.ts / input/use-object-drag.ts / canvas-stage.tsx）の
// 移行は、変更範囲を必要最小限に保つため本対応のスコープ外とし、将来の改善対象とする。
import { customAlphabet } from "nanoid";

// 紛らわしい文字（0 / O / o / 1 / l / I）を除いた 56 文字 × 16 桁。
const generate = customAlphabet("23456789abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ", 16);

/** 新規キャンバスオブジェクトの id を採番する。 */
export function generateCanvasObjectId(): string {
  return generate();
}
